import { FormConfigItem, FormValueMap } from '@navstation-portal/reporting/data-model/offshore-report';
import {
  FormSectionStateArray,
  StateField,
  StateFieldType,
} from '@navstation-portal/reporting/data-model/vessel-report';
import { initStateField } from '../offshore-report-utils/store.utility';

export function createDynamicSectionState(
  formConfig?: FormConfigItem[] | null
): Record<string, StateField<StateFieldType>> {
  if (!formConfig?.length) return {};

  return Object.fromEntries(
    formConfig.map((item) => [item.id, initStateField<FormValueMap[typeof item.type]>()])
  ) as Record<string, StateField<StateFieldType>>;
}

export type StoreRecord = Record<string, Record<string, StateField<StateFieldType> | FormSectionStateArray>>;

export const getFieldFromState = (
  state: StoreRecord,
  sectionId: string,
  fieldId: string
): StateField<StateFieldType> | FormSectionStateArray | undefined => {
  return state[sectionId]?.[fieldId];
};

export const getFieldValueFromState = <
  TState extends StoreRecord,
  TSectionId extends keyof TState,
  TFieldId extends keyof TState[TSectionId],
>(
  formState: TState,
  sectionId: TSectionId,
  fieldId: TFieldId,
  index?: number,
  nestedFieldId?: string
) => {
  const field = getFieldFromState(formState, sectionId as string, fieldId as string);
  if (!field) return;

  if (isStateField(field)) return field.value;

  if (index == null || !nestedFieldId) return;

  const entry = field[index];
  if (!entry) return;

  const nestedField = entry[nestedFieldId];
  if (!nestedField) return;

  return nestedField.value;
};

export const isNullOrNaN = (value: number | null | undefined) => {
  return value == null || isNaN(value);
};

export const isStateField = (
  entry: StateField<StateFieldType> | FormSectionStateArray
): entry is StateField<StateFieldType> => {
  if (!entry) return false;
  return (
    (entry as StateField<StateFieldType>).status !== undefined &&
    (entry as StateField<StateFieldType>).pristine !== undefined &&
    (entry as StateField<StateFieldType>).touched !== undefined
  );
};
